import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { TextAreaBlockStateType } from '@unifyapps/defs/blocks/TextArea/types';
import type { Action } from '@unifyapps/defs/types/action';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importTextAreaComponent = () =>
  import(
    /* webpackChunkName: "text-area-block" */
    './TextArea'
  );

const TextArea = lazy(importTextAreaComponent);

class TextAreaBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'TextArea';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  useBlockRef?: boolean | undefined = true;

  getBlockControlMethods() {
    return [
      {
        id: 'resetTextArea',
        label: 'Reset',
        method: (blockState: TextAreaBlockStateType, action: Action) => {
          const { methodPayload } = action.payload as {
            methodPayload: {
              resetToDefault?: boolean;
            };
          };

          const { resetToDefault } = methodPayload;

          return {
            ...blockState,
            resetToDefault,
          } as TextAreaBlockStateType;
        },
      },
      {
        id: 'focusTextArea',
        label: 'Focus',
        method: (
          blockState: TextAreaBlockStateType,
          _action: Action,
          blockRef?: HTMLTextAreaElement,
        ) => {
          if (!blockState.isFocused && blockRef) {
            blockRef.focus();
          }
          return Promise.resolve();
        },
      },
    ];
  }

  getComponent() {
    return TextArea;
  }
}

export default TextAreaBlockStateDefinition;
